import type {ObjectFieldLayout, ObjectLayout} from "@/shared/graphql/types";
import {MenuItem} from "@/shared/components/ui/menu";
import {ComponentAware} from "@/shared/composable/global.model.ts";
import {useTenantStore} from "@/shared/stores/tenant.store.ts";

export function objectLayoutForObject(objectLayouts: Array<ObjectLayout>, objectType: String): ObjectFieldLayout {
    return objectLayouts.find((ol) => ol.type.valueOf() === objectType.toUpperCase())?.layout
}

export const hasFeature = (name: string) => {
    const tenantStore = useTenantStore()
    return tenantStore.hasFeature(name)
}

export type ComponentMenuType = MenuItem & ComponentAware